export default __webpack_public_path__ + "static/media/AGO_maps_level-1.c78db421.png";